"use client";

import React from "react";
import { Carousel } from "@/components/ui/carousel/carousel";
import { Image } from "@/components/ui/Image";

export interface ImageSliderBlockProps {
  /**
   * Array of images to display in the slider
   */
  images: Array<{
    src: string;
    alt: string;
    width?: number;
    height?: number;
  }>;
  /**
   * Optional className for the component
   */
  className?: string;
}

/**
 * ImageSliderBlock component that renders a carousel of images.
 * Configuration:
 * - No navigation arrows
 * - overflowVisible: true
 */
export const ImageSliderBlock: React.FC<ImageSliderBlockProps> = ({
  images,
  className,
}) => {
  const carouselItems = images.map((image, index) => (
    <div key={index} className="relative h-full overflow-hidden rounded-lg">
      <Image
        src={image.src}
        alt={image.alt}
        width={image.width ?? 1200}
        height={image.height ?? 675}
        quality={75}
        objectFit="cover"
        className="h-full w-fit"
      />
    </div>
  ));

  return (
    <div className="overflow-hidden">
      <div className={`container ${className}`}>
        <Carousel
          items={carouselItems}
          showArrows={true}
          overflowVisible={true}
          arrowPosition="bottom"
          opts={{
            align: "start",
            loop: false,
            dragFree: true,
          }}
          className="col-span-full"
          itemClassName="h-60 md:h-96 lg:h-[34rem]"
        />
      </div>
    </div>
  );
};
